export enum StatisticsTabsType {
  Personal = 'Personal',
  Project = 'Project',
}
